// extracted by mini-css-extract-plugin
export var indeterminate = "_59-5";
export var md = "_59-4";
export var semantic = "_59-6";
export var sm = "_59-3";
export var text = "_59-7";
export var toggleInput = "_59-0";
export var toggleSwitch = "_59-1";
export var xs = "_59-2";